<template>  
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12">
        <div class="text-center mt-5">
          <h2 class="categoria-title">Explora la Encuesta Nacional del Nuevo Dia</h2>          
        </div>
        <div class="mt-3 text-center"> 
          <span>Selecciona una categoria:</span>
          <div class="mt-3">
            <b-form-select data-icon="bi bi-funnel-fill" v-model="categorySelected" :options="listaCategorias"></b-form-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <CategoryPreguntas :data_preguntas="filteredPreguntas"/>
        <AvisoConfi/>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { filter, map, uniq, kebabCase } from 'lodash'
import IframeResizer from '@/utils/iframe-resizer'
import CategoryPreguntas from '@/components/CategoryPreguntas.vue'
import AvisoConfi from '@/components/AvisoConfi.vue'

export default {
  name: 'CategoryHome',
  data() {
    return {
      categorySelected: 'Pulso del país'
    }
  },
  components: {        
    CategoryPreguntas,
    AvisoConfi
  },
  methods: {
    kebabCase
  },
  computed: {
    ...mapState({
      data_preguntas: state => state.encuesta.data_preguntas
    }),
    filteredPreguntas() {
      return filter(this.data_preguntas, ['category', this.categorySelected])
    },
    listaCategorias() {
      /*
        [{
          "title": "La divina comedia",
          "category": "Romance"
        },
        {
          "title": "GoT",
          "category": "Ficción"
        },
        {
          "title": "Vikings",
          "category": "Ficción"
        }]

        ["Romance", "Ficción", "Ficción"]
      */
      let categorias = uniq(map(this.data_preguntas, 'category'))
      return map(categorias, item => {
        return {
          value: item,
          text: item
        }
      })
    }
  },
  mounted () {
    IframeResizer.create()
    this.widthContainer = this.$refs['widthContainer'].offsetWidth
    window.addEventListener('resize', () => {
      this.widthContainer = this.$refs['widthContainer'].offsetWidth
		})
  },  
}
</script>